import React from 'react';
import {
  Box,
  Chip,
  Autocomplete,
  TextField,
  Checkbox,
  FormControlLabel,
} from '@mui/material';

const CountrySelector = ({
  regionName,
  countries,
  selectedCountries,
  onCountryToggle,
  error,
}) => {
  // Ensure countries is always an array, default to empty array if undefined/null
  const countryList = countries || [];
  const hasCountries = countryList.length > 0;

  // Check if all countries are selected
  const allSelected = hasCountries && selectedCountries.length === countryList.length;
  const someSelected = selectedCountries.length > 0 && selectedCountries.length < countryList.length;

  const handleChange = (event, newValue) => {
    // This logic is simplified because Autocomplete now manages the selected values array.
    // We just need to pass the whole new array to the parent.
    onCountryToggle(newValue);
  };

  // Handle Select All toggle
  const handleSelectAllToggle = (event) => {
    if (event.target.checked) {
      // Select all countries
      onCountryToggle([...countryList]);
    } else {
      // Deselect all countries
      onCountryToggle([]);
    }
  };

  return (
    <Box>
      {/* Select All Checkbox */}
      {hasCountries && (
        <FormControlLabel
          control={
            <Checkbox
              checked={allSelected}
              indeterminate={someSelected}
              onChange={handleSelectAllToggle}
              color="primary"
              size="small"
            />
          }
          label={`Select All Countries (${selectedCountries.length}/${countryList.length})`}
          sx={{ mb: 1, ml: 0 }}
        />
      )}

      {/* Multi-select Dropdown */}
      <Autocomplete
        multiple
        id="country-selector"
        options={countryList}
        value={selectedCountries}
        onChange={handleChange}
        getOptionLabel={(option) => option.name}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        disabled={!hasCountries}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label={`Countries for ${regionName}`}
            placeholder={
              !hasCountries
                ? "No available countries"
                : selectedCountries.length === 0
                  ? "Select countries..."
                  : ""
            }
            error={!!error}
            helperText={
              !hasCountries
                ? "No countries available for this region"
                : error || "At least one country must be selected"
            }
            size="small"
            FormHelperTextProps={{
              style: { color: error ? undefined : !hasCountries ? 'grey' : 'grey' }
            }}
          />
        )}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              label={option.name}
              {...getTagProps({ index })}
              key={option.id}
              color="primary"
              size="small"
              sx={{ fontSize: '0.875rem' }}
            />
          ))
        }
        sx={{
          '& .MuiOutlinedInput-root': {
            padding: '4px',
          },
        }}
        noOptionsText="No countries available"
        disableCloseOnSelect
      />
    </Box>
  );
};

export default CountrySelector;

